// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-_Ab2b","bannerWrapper":"jgp-3yA48","bannerItem":"jgp-mHq24","copyBold":"jgp-cLN2J"};